import "stream";
export default class RenderData {
    constructor(barDisplayMode, options) {
        this.barDisplayMode = barDisplayMode;
        this.options = options;
    }
}
